<template>
    <section v-if="displayModal" id="mobileInstallationDialog" class="sm:hidden modal-dialog relative">
        <div id="customModal">
            <div class="modal-backdrop" />
            <div id="staticModal" tabindex="-1" aria-hidden="true"
                :class="`fixed top-0 left-0 right-0 z-50  p-4 overflow-hidden w-full  md:inset-0 h-[calc(100%-1rem)] max-h-full`">
                <transition name="dropdown">
                    <div :class="`relative modal-inner w-full max-w-2xl max-h-full`.trim()">
                        <!-- Modal content -->
                        <div class="relative bg-white rounded-[28px] shadow w-[95%] xs:w-[310px] mx-auto">
                            <!-- Modal header -->
                            <div :class="`flex w-full justify-end items-center pt-2.5 px-2.5 rounded-t`">
                                <button @click="() => handleCloseDialog(false)" type="button"
                                    class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 inline-flex items-center">
                                    <img :src="timesIcon" alt="" width="19" height="19"
                                        class="h-[17px] w-[17px] md:h-[18px] md:w-[18px] lg:h-[19px] lg:w-[19px]" />
                                </button>
                            </div>
                            <!-- modal body -->
                            <div class="px-2 pb-2 overflow-x-hidden">
                                <!-- title -->
                                <h1 class="font-bold text-center">
                                    <span class="text-[0.853rem] xs:text-[13.8px] sm:text-[15px] inline-block mb-0.5">
                                        {{ $t('user.for_better_experience') }}
                                    </span>
                                    <br />
                                    <span class="text-[0.979rem] xs:text-[17.8px] sm:text-[19px]">
                                        {{ $t('user.downlad_cezma_app') }}
                                    </span>
                                </h1>

                                <div class="flex flex-col items-center mt-6 sx:mt-7 w-[76%] xs:w-[80%] mx-auto">
                                    <!-- app installation artwork -->
                                    <img :src="appInstallationArtwork" alt width="212" height="178" />
                                    <div class="flex flex-nowrap gap-1.5 mt-3.5 sm:mt-4">
                                        <a v-if="appLinkOnAndriod" :href="appLinkOnAndriod"
                                            aria-label="Download the Cezma app on Android" target="_blank"
                                            class="object-contain cursor-pointer">
                                            <img :src="playStoreIcon" alt aria-label="Download from the play store" />
                                        </a>
                                        <a v-if="appLinkOnIOS" :href="appLinkOnIOS"
                                            aria-label="Download the Cezma app on App store" target="_blank"
                                            class="object-contain cursor-pointer">
                                            <img :src="appStoreIcon" alt aria-label="Download from the App store" />
                                        </a>
                                    </div>
                                    <div class="flex flex-nowrap gap-1 justify-center w-full mt-[1.08rem] mb-5">
                                        <button @click="downloadAppOnRelativePlatform"
                                            class="mx-auto bg-primary text-[15px] text-white px-2 py-2 min-w-[130px] rounded-[21px]"
                                            aria-label="Download app">
                                            <span class="inline-block align-middle">
                                                {{ $t('user.download') }}
                                            </span>
                                            {{ " " }}
                                            <img :src="arrowDownIcon"
                                                class="inline-block align-middle object-contain w-[12.5px] sm:w-[13px] sm:h-[14.5px]"
                                                width="13" height="14.9" alt />
                                            <span class="sr-only">Download app</span>
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </section>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useGlobalStore } from "@/store/Modules/global.js";
import timesIcon from "@/assets/icons/times.svg";
import arrowDownIcon from "@/assets/icons/arrow_down.svg";
import playStoreIcon from "@/assets/icons/playstore_light.svg";
import appStoreIcon from "@/assets/icons/appstore_light.svg";
import appInstallationArtwork from "@/assets/images/app_installation.svg";
import { isEmpty } from '@/helpers';

export default {
    name: "MobileInstallationDialog",
    data() {
        return {
            timesIcon,
            showDialog: true,
            appInstallationArtwork,
            appStoreIcon,
            playStoreIcon,
            arrowDownIcon
        };
    },
    props: {
        infoData: {
            type: Object,
            required: false,
            default: {
                description: 'please download app',
            }
        },
    },
    computed: {
        ...mapState(useGlobalStore, ['layout', 'displayMobileInstallationDialog']),
        isPlatformsLinksExist() {
            return this.layout?.platforms?.android_link || this.layout?.platforms?.ios_link
        },
        appLinkOnAndriod() {
            return this.layout?.platforms?.android_link;
        },
        appLinkOnIOS() {
            return this.layout?.platforms?.ios_link;
        },
        displayModal() {
            return !!(this.showDialog && this.displayMobileInstallationDialog && this.deviceType() != 'desktop' && !isEmpty(this.layout?.platforms || {}));
        }
    },
    methods: {
        ...mapActions(useGlobalStore, ['updateDisplayingMobileInstallationDialog']),
        handleCloseDialog() {
            this.showDialog = false;
            this.updateDisplayingMobileInstallationDialog(false);
        },
        deviceType() {
            const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            const isAndroid = /Android/i.test(navigator.userAgent);
            const isiOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
            if (isMobile) {
                if (isAndroid) {
                    return 'android'
                } else if (isiOS) {
                    return 'ios'
                } else {
                    return false
                }
            } else {
                return 'desktop'
            }
        },
        downloadAppOnRelativePlatform() {
            let downloadLink = this.appLinkOnAndriod;
            if (this.deviceType() == 'android') {
                downloadLink = this.appLinkOnAndriod;
            } else {
                downloadLink = this.appLinkOnIOS;
            }
            window.open(downloadLink || "#", '_blank');
        },
    }
};
</script>

<style scoped>
#staticModal {
    position: fixed;
    inset: 0;
    max-height: 100vh;
    max-height: 100svh;
    width: 100%;
    z-index: 150;
}

.gradient-bg {
    background: #020024;
    background: linear-gradient(14deg, #080451 1%, #0d0d83 49%, #163761 93%, #163761);
}
</style>
